import { Column } from 'react-table';

import { Device } from '@/core/hostmanagement/open-amt/model';

export const hostname: Column<Device> = {
  Header: 'Имя узла',
  accessor: (row) => row.hostname || '-',
  id: 'hostname',
  disableFilters: true,
  canHide: true,
  sortType: 'string',
  Filter: () => null,
};
